<template>
  <HubContainer id="branchGlobalSettingsHub">

    <template v-if="atLeastSuperAdmin">
      <HubSection icon="icon/hub/subscription.svg"
                  :title="$t('services.title')"
                  :description="$t('services.branch_description')"
                  :buttonAction="goToServices">
      </HubSection>

      <HubSection icon="icon/hub/file-import.svg"
                  :title="$t('advanced_navigation.file_import')"
                  :description="$t('advanced_navigation.file_import_description')"
                  :buttonAction="goToImport">
      </HubSection>

      <HubSection icon="icon/hub/gift-cards.svg"
                  :title="$t('advanced_navigation.branch_payment')"
                  :description="$t('advanced_navigation.branch_payment_description')"
                  :buttonAction="goToBranchPayment">
      </HubSection>

      <HubSection icon="icon/hub/settings.svg"
                  :title="$t('services.online_ordering')"
                  :description="$t('services.online_ordering_description')"
                  :buttonAction="goToOnlineOrdering">
      </HubSection>

      <HubSection icon="icon/hub/mobile-app.svg" v-if="moduleActivated.mobileApp"
                  :title="$t('settings.mobileapp')"
                  :description="$t('mobileApp_description')"
                  :buttonAction="goToMobileApp">
      </HubSection>

      <HubSection icon="icon/hub/inventory.svg"
                  :title="$t('branches.inventories')"
                  :description="$t('branches.inventories_description')"
                  :buttonAction="goToInventories">
      </HubSection>

      <HubSection icon="icon/hub/customer-accounts.svg" v-if="!exactlyDistributor"
                  :title="$t('loyalty.title')"
                  :description="$t('loyalty.description')"
                  :buttonAction="goToLoyalty">
      </HubSection>

      <HubSection icon="icon/hub/clone-inventory.svg"
                  :title="$t('settings_admin.clone_inventory')"
                  :description="$t('settings_admin.clone_inventory_description')"
                  :buttonAction="goToClone">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "branchGlobalSettingsHub",

    components: {HubSection, HubContainer},

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.global_reports";
      this.$store.state.pageIcon = "/icon/nav/analytics.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
    },

    methods: {
      goToImport() {
        this.$router.push(this.$router.buildContext("/file-import"));
      },
      goToBranchPayment() {
        this.$router.push(this.$router.buildContext("/branch-payment"));
      },
      goToOnlineOrdering() {
        this.$router.push(this.$router.buildContext("/settings/services/online-ordering"));
      },
      goToMobileApp() {
        this.$router.push(this.$router.buildContext("/settings/services/mobile-app"));
      },
      goToLoyalty() {
        this.$router.push(this.$router.buildContext("/loyalty-config"));
      },
      goToClone() {
        this.$router.push(this.$router.buildContext("/clone-inventory"));
      },
      goToServices() {
        this.$router.push(this.$router.buildContext("/branch/services"));
      },
      goToInventories() {
        this.$router.push(this.$router.buildContext("/branch/inventories"));
      }
    }
  }
</script>